import React, { useEffect } from "react";
import sapImg from "../../../../Images/sapbannerpage.png";
import aboutimg from "../../../../Images/sap1.png";
import sapImg2 from "../../../../Images/sap2.png";
import sapbanner from "../../../../Images/sapbanner.png";
import "./Sap.css";
import ScrollMagic from "scrollmagic";

const Sappage = () => {
  useEffect(() => {
    const controller = new ScrollMagic.Controller();
    window.scrollTo(0, 0);
    setTimeout(() => {
      const triggerElement = document.getElementById("triggerPinned");

      if (window.innerWidth > 768 && triggerElement) {
        new ScrollMagic.Scene({
          triggerElement: triggerElement,
          triggerHook: 0,
        })
          .setPin(triggerElement)
          .addTo(controller);
      }
    }, 0);

    return () => controller.destroy();
  }, []);

  return (
    <div>
      <div className="sap-banner-page" id="triggerPinned">
        <img src={sapImg} alt="sap" />
      </div>
      <div
        className="white-section"
        style={{ marginTop: "20px", position: "relative", zIndex: "1" }}
      >
        <div className="sapContent mainContainer" style={{ paddingTop: "20px" }}>
          <div className="sapContnetLeft">
            <h1
              style={{
                fontWeight: 600,
                fontSize: "16px",
                marginBottom: ".5rem",
              }}
            >
              Introduction to SAP
            </h1>
            <p>
              SAP stands as a global leader in providing enterprise software solutions, designed to
              facilitate business operations and promote growth across various sectors. With its
              comprehensive suite of services, SAP caters to a wide array of business needs through
              its modules in Enterprise Resource Planning (ERP), Customer Relationship Management
              (CRM), Supply Chain Management (SCM), Human Resources (HR), and more. Whether you are
              a small business or a large enterprise, SAP delivers tailored solutions that help
              streamline your processes, enhance customer relations, and harness data-driven
              insights for strategic decision-making.
            </p>
          </div>
          <div className="sapContentRight">
            <img src={aboutimg} alt="sap" />
          </div>
        </div>
        <div className="sapKeyContent mainContainer">
          <h3>Key Modules of SAP</h3>
          <ol className="keyitem">
            <li>
              <span>SAP ERP</span>: Integrates core business functions such as finance, sales,
              procurement, and manufacturing into a unified platform, enhancing real-time visibility
              and supporting effective decision-making.
            </li>
            <li>
              <span>SAP CRM </span>: Enhances customer engagement and sales by managing interactions
              across various channels, thereby improving customer satisfaction and business
              performance.
            </li>
            <li>
              <span>SAP SCM</span>: Optimizes supply chain operations with tools for efficient
              demand and supply planning, inventory management, and logistics.
            </li>
            <li>
              <span>SAP SCM </span>: Manages human resources processes including payroll, talent
              management, and workforce planning to help attract, develop, and retain talen
            </li>
            <li>
              <span>SAP HR </span>: Turns data into actionable insights through robust reporting,
              analytics, and visualization tools, aiding in comprehensive business analysis.
            </li>
            <li>
              <span>SAP BI </span>: Turns data into actionable insights through robust reporting,
              analytics, and visualization tools, aiding in comprehensive business analysis.
            </li>
            <li>
              <span>And many more</span>: Including SAP HCM, SAP SRM, SAP EWM, SAP PLM, and SAP EHS,
              each addressing specific business needs and enhancing operational efficiency.
            </li>
          </ol>
        </div>
        <div className="implSap mainContainer">
          <div className="implsapLeft">
            <h3>Our SAP Implementation Plan</h3>
            <p>
              We begin each SAP project with a thorough assessment of your business requirements,
              objectives, and current systems to tailor our approach. Our implementation process
              includes:
            </p>
            <ul className="implItem">
              <li>Detailed project planning with clear milestones and timelines.</li>
              <li>
                Comprehensive team assembly involving consultants, developers, and stakeholders
              </li>
              <li>Customization of SAP functionalities to meet unique business requirements.</li>
              <li>Data migration from legacy systems to the SAP platform.</li>
              <li>Rigorous testing to ensure functionality and performance.</li>
              <li>User training and support to maximize system adoption and efficiency.</li>
              <li>Phased rollouts to minimize operational disruption.</li>
            </ul>
          </div>
          <div className="implRight">
            <img src={sapImg2} alt="sap2" />
          </div>
        </div>
        <div className="whysapContent mainContainer">
          <h1>Why Choose Us for Your SAP Implementation?</h1>
          <img src={sapbanner} alt="sapbanner" />
          <p>
            Our deep expertise in SAP technologies and a proven track record of successful
            implementations make us the ideal partner for your SAP project. We prioritize client
            collaboration and are dedicated to transforming your business processes through
            innovative SAP solutions. By choosing us, you benefit from:
          </p>
          <ul className="sapItem">
            <li>A seasoned team of experts committed to your project from start to finish.</li>
            <li>Customized solutions designed to meet your unique business needs.</li>
            <li>
              A focus on delivering tangible business outcomes and a high return on investment.
            </li>
            <li>Continuous support and optimization of your SAP systems post-implementation.</li>
          </ul>
        </div>
        <div className="whysapcontainer mainContainer">
          <div className="whysap">
            <h1>Why SAP?</h1>
            <p>
              SAP's unmatched combination of comprehensive capabilities and innovative solutions
              makes it the preferred choice for businesses aiming to future-proof their operations.
              With SAP's wide range of modules, businesses can streamline operations, foster digital
              transformation, and maintain a competitive edge in the dynamic market landscape.
            </p>
          </div>
          <div className="sapComp">
            <h1>SAP's Competitors</h1>
            <p>
              SAP competes with several other major players in the enterprise software market,
              including Oracle, Microsoft Dynamics 365, and Salesforce, each offering unique
              strengths and focuses. Choosing between SAP and its competitors will depend on
              specific business needs, industry requirements, and budget considerations.
            </p>
          </div>
          <div className="conclusion">
            <h1>Resolution</h1>
            <p>
              Leverage SAP's robust suite of enterprise software solutions to drive efficiency,
              growth, and success in your organization. With our expert guidance and comprehensive
              support, we'll help you navigate your SAP journey to achieve optimal results and a
              substantial return on investment. Embrace the power of SAP with us and transform your
              business into a more agile, insightful, and efficient enterprise.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sappage;
